import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config.js";
import { AppComponent } from "./app/app.component.js";

import * as Sentry from "@sentry/angular";
import * as L from 'leaflet';

// Suppress MutationObserver errors from browser extensions
// These errors come from third-party content scripts and don't affect app functionality
if (typeof window !== 'undefined') {
  // Suppress console errors specifically from browser extension content scripts
  const originalConsoleError = console.error;
  console.error = function(...args: any[]) {
    const errorMessage = String(args[0] || '');
    // Only suppress errors that are clearly from browser extension content scripts
    if (
      errorMessage.includes('MutationObserver.observe: Argument 1 is not an object') &&
      (errorMessage.includes('web-client-content-script') || 
       args.some(arg => String(arg).includes('web-client-content-script')))
    ) {
      return; // Suppress the error silently
    }
    // Call original console.error for all other errors
    originalConsoleError.apply(console, args);
  };

  // Suppress window.onerror for browser extension errors
  const originalError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    // Suppress MutationObserver errors from browser extensions
    if (
      typeof message === 'string' &&
      message.includes('MutationObserver.observe: Argument 1 is not an object') &&
      (typeof source === 'string' && source.includes('web-client-content-script'))
    ) {
      return true; // Suppress the error
    }
    // Call original error handler if it exists
    if (originalError) {
      return originalError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };
}

Sentry.init({
  dsn: "https://93b6800f542fc0bab79d188eb94e653f@o4508824472387584.ingest.us.sentry.io/4508824737415168",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/dev\.idownsize\.com\.au/, /^https:\/\/app\.idownsize\.com\.au/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

(L.Icon.Default as any).mergeOptions({
  iconRetinaUrl: 'assets/leaflet/marker-icon-2x.png',
  iconUrl: 'assets/leaflet/marker-icon.png',
  shadowUrl: 'assets/leaflet/marker-shadow.png'
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
